/* globals Store */
import ssoApi from './api/sso-api'
import {
  sendErrorNotice,
  dealUnsuccessResponse,
  closeNotice
} from '@/utils/store-util.js'
export default {
  login (email, pass, cb) {
    cb = arguments[arguments.length - 1]
    let data = email + ':' + pass
    // Base64 Encoding -> btoa
    let hash = btoa(data)
    data = 'Basic ' + hash
    ssoApi.login('boot/login/tap', data).then((res) => {
      if (res.data.status === 'SUCCESS' && res.data.data[0].authorities.indexOf('ROLE_TAP_TRAINER') !== -1) {
        const token = res.headers['user-auth-token']
        const user = res.data.data[0]
        Store.dispatch('user/updateUser', {user, token})
        // start fetching profile completion
        Store.dispatch('user/updateCompletion', (status) => {
          if (status) {
            this.onChange(true, this.profileMode())
            // eslint-disable-next-line
            if (cb) cb()
          } else {
            this.logout()
          }
        })
        // end fetching profile completion
      } else {
        console.log(res.data)
        dealUnsuccessResponse(res.data)
      }
    }, (err) => {
      console.log(err)
      sendErrorNotice(null, err.response.data.statusMessage)
      closeNotice(null, 20000)
    })
  },
  getToken () {
    return Store.state.user.token
  },
  logout () {
    Store.dispatch('profile/logout')
    Store.dispatch('user/logout')
    // eslint-disable-next-line
    this.onChange(false, this.profileMode())
  },
  loggedIn () {
    return !!Store.state.user.token
  },
  profileMode () {
    return Store.state.user.completion < 75
  },
  onChange () {}
}



// WEBPACK FOOTER //
// ./src/utils/auth.js